import styled from 'styled-components';

export const AchievementContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2rem;
  padding-left: 4rem;
  padding-top: 2rem;
`;

export default {
  AchievementContainer,
};
